//admin panel AI integartion TextViewUploader.jsx


import React, { useMemo, useState } from "react";
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';

export default function TextViewUploader() {
  const [fileName, setFileName] = useState("");
  const [text, setText] = useState("");
  const [instruction, setInstruction] = useState(
    "Give an overview with: 1) 5-line summary 2) key points (bullets) 3) action items (bullets) 4) important names/dates/numbers."
  );

  const [overview, setOverview] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const [filter, setFilter] = useState("customer_support");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const { user } = useContext(AuthContext)

  // ✅ Change this to your actual PHP endpoint URL
  // Example: "https://skillsuprise.com/api/overview.php"
  const API_URL = useMemo(() => "https://skillsuprise.com/chatgpt-api.php", []);

  // const readFileAsText = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = () => resolve(String(reader.result || ""));
  //     reader.onerror = () => reject(new Error("Failed to read the file."));
  //     reader.readAsText(file);
  //   });

  // const onPickFile = async (e) => {
  //   setErr("");
  //   setOverview("");

  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   const name = file.name || "";
  //   const isTxt = name.toLowerCase().endsWith(".txt") || file.type === "text/plain";
  //   if (!isTxt) {
  //     setErr("Please upload only a .txt (text) file.");
  //     return;
  //   }

  //   setFileName(name);

  //   try {
  //     const content = await readFileAsText(file);

  //     // safety limit - match your PHP limit
  //     if (content.length > 200000) {
  //       setErr("File is too large. Please split and upload a smaller .txt file.");
  //       return;
  //     }

  //     setText(content);
  //   } catch (error) {
  //     setErr(error?.message || "Unable to read the file.");
  //   }
  // };

  const generateOverview = async () => {
    setErr("");
    setOverview("");

    if (!text.trim()) {
      setErr("Upload a .txt file first (or paste text).");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          text,
          fileName,
          instruction,
        }),
      });

      // If PHP returns non-JSON error text, handle it
      const contentType = res.headers.get("content-type") || "";
      let data = null;

      if (contentType.includes("application/json")) {
        data = await res.json();
      } else {
        const t = await res.text();
        throw new Error(t || `Server error (${res.status})`);
      }

      if (!res.ok) {
        throw new Error(data?.error || `Request failed (${res.status})`);
      }

      setOverview(data?.overview || "No overview returned.");
    } catch (error) {
      setErr(error?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const clearAll = () => {
    setFileName("");
    setText("");
    setOverview("");
    setErr("");
  };

  const copyOutput = async () => {
    try {
      await navigator.clipboard.writeText(overview || "");
    } catch {
      // ignore
    }
  };



  const fetchDataset = async () => {
    setErr("");
    setText("");
  
    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("type", filter);
      formData.append("from", fromDate);
      formData.append("to", toDate);
  
      const res = await fetch(
        "https://internalapi.skillsuprise.com/admin-get-ai-dataset.php",
        {
          method: "POST",
          body: formData,
        }
      );
  
      const data = await res.json();
  
      if (!res.ok || data.status !== "success") {
        throw new Error(data.message || "Failed to fetch data");
      }
  
      const formatted = JSON.stringify(data.data, null, 2);
      setText(formatted);
  
    } catch (error) {
      setErr(error.message);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <h2 style={{ margin: 0 }}>Upload TXT → Get Overview (PHP + OpenAI)</h2>
        <p style={{ marginTop: 8, color: "#555" }}>
          Upload a <b>.txt</b> file or paste text, then click <b>Generate Overview</b>.
        </p>

    

<div style={{ marginTop: 12 }}>
  <label style={styles.label}>Select Data Source</label>
  <select value={filter} onChange={(e)=>setFilter(e.target.value)} style={styles.textarea}>
    <option value="customer_support">Customer Support</option>
    <option value="doubt_support">Doubt Support</option>
    <option value="course_registration">Course Registration</option>
    <option value="student_list">Student List</option>
    <option value="assignment_submission">Assignment Submission</option>
    <option value="project_submission">Project Submission</option>
  </select>
</div>

<div style={{ marginTop: 15 }}>
  <div style={{ display: "flex", gap: 20, alignItems: "flex-end", flexWrap: "wrap" }}>

    {/* FROM DATE */}
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label style={styles.label}>From</label>
      <input
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        style={{ ...styles.textarea, minWidth: 380 }}
      />
    </div>

    {/* TO DATE */}
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label style={styles.label}>To</label>
      <input
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        style={{ ...styles.textarea, minWidth: 380 }}
      />
    </div>

    {/* BUTTON */}
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label style={{ visibility: "hidden" }}>Fetch</label>
      <button onClick={fetchDataset} style={styles.btnSecondary}>
        Fetch Data
      </button>
    </div>

  </div>
</div>


        <div style={{ marginTop: 12 }}>
          <label style={styles.label}>Instruction (optional)</label>
          <textarea
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
            rows={3}
            style={styles.textarea}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label style={styles.label}>Text (preview / editable)</label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={10}
            placeholder="Upload a .txt file or paste text here..."
            style={styles.textarea}
          />
          <div style={{ marginTop: 6, fontSize: 12, color: "#666" }}>
            Characters: {text.length} / 200000
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
          <button
            onClick={generateOverview}
            disabled={loading || !text.trim()}
            style={{
              ...styles.btn,
              opacity: loading || !text.trim() ? 0.6 : 1,
              cursor: loading || !text.trim() ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Generating..." : "Generate Overview"}
          </button>

          <button onClick={clearAll} style={styles.btnSecondary}>
            Clear
          </button>

          <button
            onClick={copyOutput}
            disabled={!overview}
            style={{
              ...styles.btnSecondary,
              opacity: !overview ? 0.6 : 1,
              cursor: !overview ? "not-allowed" : "pointer",
            }}
          >
            Copy Output
          </button>
        </div>

        {err ? (
          <div style={styles.errorBox}>
            <b>Error:</b> {err}
          </div>
        ) : null}

        <div style={{ marginTop: 16 }}>
          <label style={styles.label}>Overview (Output)</label>
          <pre style={styles.output}>
            {overview || "Output will appear here after generating overview."}
          </pre>
        </div>

        <div style={{ marginTop: 10, fontSize: 12, color: "#777" }}>
          Endpoint: <code>{API_URL}</code>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    maxWidth: 980,
    margin: "24px auto",
    padding: "0 14px",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    border: "1px solid #e6e6e6",
    borderRadius: 12,
    padding: 16,
    background: "#fff",
    boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
  },
  row: {
    marginTop: 10,
    padding: 10,
    border: "1px dashed #ccc",
    borderRadius: 10,
  },
  label: { display: "block", fontWeight: 700, marginBottom: 6 },
  textarea: {
    width: "100%",
    borderRadius: 10,
    border: "1px solid #ddd",
    padding: 10,
    outline: "none",
    fontSize: 14,
    lineHeight: 1.4,
  },
  btn: {
    borderRadius: 10,
    border: "1px solid #111",
    padding: "10px 14px",
    background: "#111",
    color: "#fff",
    fontWeight: 700,
  },
  btnSecondary: {
    borderRadius: 10,
    border: "1px solid #aaa",
    padding: "10px 14px",
    background: "#fff",
    color: "#111",
    fontWeight: 700,
  },
  output: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    border: "1px solid #eee",
    borderRadius: 10,
    padding: 12,
    background: "#fafafa",
    minHeight: 140,
  },
  errorBox: {
    marginTop: 12,
    padding: 10,
    borderRadius: 10,
    border: "1px solid #ffb3b3",
    background: "#fff0f0",
    color: "#b00020",
  },
};